export const MEASUREMENT_STATUS_TO_SEND = 1;
export const MEASUREMENT_STATUS_IN_PROGRESS = 2;
export const MEASUREMENT_STATUS_COMPLETED = 3;

function getMeasurementStatusDescription(status, translations) {
  switch (status) {
    case MEASUREMENT_STATUS_TO_SEND:
      return translations.measurementStatusPlanned;
    case MEASUREMENT_STATUS_IN_PROGRESS:
      return translations.measurementStatusInProgress;
    case MEASUREMENT_STATUS_COMPLETED:
      return translations.measurementStatusCompleted;
    default:
      return translations.statusUnknown;
  }
}

export default getMeasurementStatusDescription;
